<template>
<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <card>
                    <h4 slot="header" class="card-title">Customer Data</h4>
                    <form @submit.prevent="addNewUser">
                        <div class="row">
                            <div class="col-md-12">
                                <base-input type="text" label="Name*" placeholder="Name" v-model="user.name"></base-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-5">
                                <base-input type="text" label="Company" placeholder="Company" v-model="user.company"></base-input>
                            </div>
                            <div class="col-md-3">
                                <base-input type="text" label="Mobile Number*" placeholder="Mobile Number" v-model="user.mobileNo"></base-input>
                            </div>
                            <div class="col-md-4">
                                <base-input type="email" label="Email" placeholder="Email" v-model="user.email"></base-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <base-input type="text" label="Address" placeholder="Home Address" v-model="user.address"></base-input>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <!-- <label>Remark</label>
                                    <textarea rows="2" class="form-control border-input" placeholder="Here can be your description" v-model="user.remark"></textarea> -->
                                    <base-input type="text" label="Remark" placeholder="Here can be your description" v-model="user.remark"></base-input>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="submit" class="btn btn-primary btn-fill float-right btn-sm">
                                Add
                            </button>
                        </div>
                    </form>
                </card>
            </div>
            <div class="col-12">
                <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
                    <template slot="header">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h4 class="card-title">Customer List</h4>
                                <!-- <p class="card-category">Here is a subtitle for this table</p> -->
                            </div>
                            <!-- <button @click="clearInput" class="btn btn-primary btn-sm">Add</button> -->
                        </div>
                    </template>
                    <template v-if="customerList.length === 0">
                        <div class="card-body">
                            <div class="col-md-12">No data</div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="card-body">
                            <div class="mb-3">
                                <button @click="deleteSelectedCustomer" class="btn btn-danger btn-sm">Delete Selected Customer</button>
                                <button @click="deleteAllCustomers" class="btn btn-danger btn-fill btn-sm ml-2">Delete All</button>
                            </div>
                            <!-- Scrollable container -->
                            <div class="table-scroll-container">
                                <table id="myTable" class="table table-hover table-striped">
                                    <thead>
                                        <tr>
                                            <th><input type="checkbox" v-model="selectAll" @change="toggleSelectAll" /></th>
                                            <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in customerList" :key="index">
                                            <template v-if="editIndex === index">
                                                <td><input type="checkbox" :value="item.id" v-model="selectedCustomer" disabled /></td>
                                                <td><input v-model="editItem.id" class="form-control" disabled /></td>
                                                <td><input v-model="editItem.name" class="form-control" /></td>
                                                <td><input v-model="editItem.company" class="form-control" /></td>
                                                <td><input v-model="editItem.mobileNo" class="form-control" /></td>
                                                <td><input v-model="editItem.email" class="form-control" /></td>
                                                <td>
                                                    <select class="form-control" v-model="editItem.status">
                                                        <option value="1">Active</option>
                                                        <option value="0">Deactivated</option>
                                                    </select>
                                                </td>
                                                <td><input v-model="editItem.address" class="form-control" /></td>
                                                <td><input v-model="editItem.remark" class="form-control" /></td>
                                                <td><input v-model="editItem.created_datetime" class="form-control" disabled /></td>
                                                <td><input v-model="editItem.updated_datetime" class="form-control" disabled /></td>
                                                <td>
                                                    <button @click="saveUser(index)" class="btn btn-success btn-sm">Save</button>
                                                    <button @click="cancelEdit" class="btn btn-secondary btn-sm">Cancel</button>
                                                </td>
                                            </template>
                                            <template v-else>
                                                <td><input type="checkbox" :value="item.id" v-model="selectedCustomer" /></td>
                                                <td>{{ item.id }}</td>
                                                <td>{{ item.name }}</td>
                                                <td>{{ item.company }}</td>
                                                <td>{{ item.mobileNo }}</td>
                                                <td>{{ item.email }}</td>
                                                <td>{{ item.status }}</td>
                                                <td>{{ item.address }}</td>
                                                <td>{{ item.remark }}</td>
                                                <td>{{ item.created_datetime }}</td>
                                                <td>{{ item.updated_datetime }}</td>
                                                <td>
                                                    <button @click="editUser(index, item)" class="btn btn-primary btn-sm">Edit</button>
                                                    <button @click="deleteUser(item.id)" class="btn btn-danger btn-sm">Delete</button>
                                                </td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </template>

                </card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Card from 'src/components/Cards/Card.vue';
import axios from 'axios';
import {
    fetchCustomer
} from 'src/utils/api';

export default {
    components: {
        Card
    },
    data() {
        return {
            editIndex: -1,
            editItem: {},
            selectedCustomer: [],
            selectAll: false,
            user: {
                name: '',
                company: '',
                mobileNo: '',
                email: '',
                address: '',
                remark: ''
            },
            tableColumns: ['Id', 'Name', 'Company', 'Contact No', 'Email', 'Status', 'Address', 'Remark', 'Create At', 'Last Update', 'Action'],
            customerList: []
        };
    },
    watch: {
        selectedUsers(val){
            if(this.selectedCustomer.length === this.customerList.length){
                this.selectAll = true
            }
            else this.selectAll = false
        }
    },
    methods: {
        clearInput() {
            this.user = {
                name: '',
                company: '',
                mobileNo: '',
                email: '',
                address: '',
                remark: ''
            };
        },
        addNewUser() {
            if (this.user.name.trim() === '') {
                alert('Name cannot be empty');
                return;
            }
            if (confirm(`Are you sure to insert ${this.user.name}?`)) {
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=create&type=customer`
                axios.post(apiUrl, this.user)
                    .then(response => {
                        if (response.data.status === 'success') {
                            alert(response.data.message);
                            this.loadCustomer();
                            this.clearInput();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        alert('Network Error: ' + error);
                    });
            }
        },
        async loadCustomer() {
            this.customerList = []
            try {
                const data = await fetchCustomer('admin');
                this.customerList = data;
                console.log(this.customerList)
                this.$nextTick(() => {
                    // Destroy existing DataTable if it exists
                    if ($.fn.DataTable.isDataTable('#myTable')) {
                        $('#myTable').DataTable().destroy();
                    }

                    // Reinitialize DataTable
                    $('#myTable').DataTable({
                        pageLength: 10, // Default number of rows to display
                        lengthMenu: [10, 25, 50, 100], // Options for number of rows per page
                        language: {
                            lengthMenu: "Show _MENU_ entries" // Customize the text for the page length menu
                        }
                    });
                });
            } catch (error) {
                alert(error.message);
            }
        },
        saveUser(index) {
            if (confirm('Are you sure to update?')) {
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=update&type=customer`
                axios.post(apiUrl, this.editItem)
                    .then(response => {
                        if (response.data.status === 'success') {
                            this.$set(this.customerList, index, this.editItem);
                            this.cancelEdit();
                            alert(response.data.message);
                            this.loadCustomer();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        alert('Network Error: ' + error);
                    });
            }
        },
        editUser(index, item) {
            this.editIndex = index;
            this.editItem = {
                ...item
            };
        },
        cancelEdit() {
            this.editIndex = -1;
            this.editItem = {};
        },
        deleteUser(id) {
            if (confirm('Are you sure to delete this customer?')) {
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=delete&type=customer`
                axios.post(apiUrl, {
                        ids: [id]
                    })
                    .then(response => {
                        if (response.data.status === 'success') {
                            alert(response.data.message);
                            this.loadCustomer();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        alert('Network Error: ' + error);
                    });
            }
        },
        deleteSelectedCustomer() {
            if (this.selectedCustomer.length === 0) {
                alert('No customers selected');
                return;
            }
            if (confirm(`Are you sure to delete selected customers? ${JSON.stringify(this.selectedCustomer)}`)) {
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=delete&type=customer`
                axios.post(apiUrl, {
                        ids: this.selectedCustomer
                    })
                    .then(response => {
                        if (response.data.status === 'success') {
                            alert(response.data.message);
                            this.selectAll = false;
                            this.loadCustomer();
                            this.selectedCustomer = [];
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        alert('Network Error: ' + error);
                    });
            }
        },
        deleteAllCustomers() {
            if (confirm('Are you sure to delete all customers?')) {
                let apiUrl = `${process.env.VUE_APP_BASE_URL}?action=delete&type=customer`
                axios.post(apiUrl, {
                        clear_all: true
                    })
                    .then(response => {
                        if (response.data.status === 'success') {
                            alert(response.data.message);
                            this.loadCustomer();
                        } else {
                            alert('Error: ' + response.data.message);
                        }
                    })
                    .catch(error => {
                        alert('Network Error: ' + error);
                    });
            }
        },
        toggleSelectAll() {
            this.selectedCustomer = this.selectAll ? this.customerList.map(customer => customer.id) : [];
        },
        toggleSelectCustomer(id) {
            const index = this.selectedCustomer.indexOf(id);
            if (index > -1) {
                this.selectedCustomer.splice(index, 1);
            } else {
                this.selectedCustomer.push(id);
            }

            this.selectAll = this.selectedCustomer.length === this.customerList.length;
        }
    },
    mounted() {
        this.loadCustomer();
    }
};
</script>

<style scoped>
.table-scroll-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    /* Smooth scrolling for touch devices */
    width: 100%;
}

.table {
    min-width: 1000px;
    /* Adjust based on your table's width */
}
</style>
